import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import AdminDashboard from "./components/admin/AdminDashboard";
import Home from "./Home";
import Publications from "./components/Publications";
import PublicationArticle from "./components/PublicationArticle";
import Login from "./components/admin/Login";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TrafficTracker from "./components/utils/TrafficTracker";
import SiteSeo from "./components/SiteSeo";
import CalendlyWidget from "./components/CalendlyWidget";
import { initGoogleAds, setupCalendlyTracking } from "./components/utils/analytics";
import "./index.css";

function AppShell() {
  const location = useLocation();
  const hideFloatingCta = location.pathname.startsWith("/admin") || location.pathname.startsWith("/login");

  useEffect(() => {
    initGoogleAds();
    const cleanupCalendly = setupCalendlyTracking();
    return () => {
      cleanupCalendly();
    };
  }, []);

  return (
    <>
      <SiteSeo />
      <TrafficTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/publications/" element={<Publications />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/:slug" element={<PublicationArticle />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!hideFloatingCta && <CalendlyWidget />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}
